module.exports = __webpack_public_path__ + "img/status_ok.e48c0bda.png";